
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function validUsername(str) {
  const valid_map = ['admin', 'editor', 'jiawenchao']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/* 小写字母*/
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validEmail(email) {
  const re = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 *  判断数据是不是Object类型的数据
 *  @param value
 *  @return {boolean}
 */

export function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

/**
 *  检查 value 是否为有效的类数组长度
 *  @param value
 *  @return {boolean}
 */

export function isLength(value) {
  return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= Number.MAX_SAFE_INTEGER
}

/**
 *  检查 value 是否是类数组
 *  @param value
 *  @return {boolean}
 */

export function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value)
}

/**
 *  检查 value 是否是函数类型
 *  @param value
 *  @return {boolean}
 */

export function isFunction(value) {
  return Object.prototype.toString.call(value) === '[object Function]'
}
/**
 *  value判断是不是为空
 *  @param value
 *  @return {boolean}
 */

export function isEmpty(value) {
  if (value == null) {
    return true
  }
  if (isArrayLike(value)) {
    return !value.length
  } else if (isPlainObject(value)) {
    for (const key in value) {
      if (hasOwnProperty.call(value, key)) {
        return false
      }
    }
  }
  return false
}

// 身份证校验器
export function validateCard(rule, value, callback) {
  value = value.trim();
  if (!value) {
    callback("该输入身份证号！");
    return;
  }
  let num = value.toUpperCase();
  // 验证长度
  if (!/(^\d{17}([0-9]|X)$)/.test(num)) {
    callback("身份证号不正确或不符合规定！");
    return;
  }
  //验证城市
  let aCity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };
  if (aCity[parseInt(num.substr(0, 2))] == null) {
    callback("身份证号不正确或不符合规定！");
    return;
  }
  // 验证生日
  let reg = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
  let arrSplit = num.match(reg);
  let dtmBirth = new Date(
    arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
  );
  let bGoodDay;
  bGoodDay =
    dtmBirth.getFullYear() == Number(arrSplit[2]) &&
    dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
    dtmBirth.getDate() == Number(arrSplit[4]);
  if (!bGoodDay) {
    callback("身份证号不正确或不符合规定！");
    return;
  }
  // 验证格式
  var valnum;
  var arrInt = new Array(
    7,
    9,
    10,
    5,
    8,
    4,
    2,
    1,
    6,
    3,
    7,
    9,
    10,
    5,
    8,
    4,
    2
  );
  var arrCh = new Array(
    "1",
    "0",
    "X",
    "9",
    "8",
    "7",
    "6",
    "5",
    "4",
    "3",
    "2"
  );
  var nTemp = 0,
    i;
  for (i = 0; i < 17; i++) {
    nTemp += num.substr(i, 1) * arrInt[i];
  }
  valnum = arrCh[nTemp % 11];
  if (valnum != num.substr(17, 1)) {
    callback("身份证号不正确或不符合规定！");
    return;
  }
  callback();
};



// WEBPACK FOOTER //
// ./src/utils/validate.js